import { motion, useReducedMotion } from 'framer-motion';

export default function HeroScrollRail({ targetId = '', label = 'Scroll' }) {
  const reduceMotion = useReducedMotion();

  const handleClick = (event) => {
    const target = targetId ? document.getElementById(targetId) : null;
    const fallback = event.currentTarget.closest('section')?.nextElementSibling;
    const destination = target || fallback;
    if (destination?.scrollIntoView) {
      destination.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <motion.button
      type="button"
      onClick={handleClick}
      className="absolute bottom-6 left-1/2 z-10 flex -translate-x-1/2 flex-col items-center gap-2 md:bottom-8"
      initial={reduceMotion ? false : { opacity: 0 }}
      animate={reduceMotion ? undefined : { opacity: 1 }}
      transition={{ delay: 1.65, duration: 0.8 }}
    >
      <span className="font-body text-[10px] uppercase tracking-[0.32em] text-copy/38">{label}</span>
      <motion.span
        className="h-8 w-px bg-gradient-to-b from-gold/70 to-transparent"
        animate={reduceMotion ? undefined : { scaleY: [0.45, 1, 0.45], opacity: [0.45, 1, 0.45] }}
        transition={{ duration: 1.8, repeat: Infinity, ease: 'easeInOut' }}
        style={{ transformOrigin: 'top' }}
      />
    </motion.button>
  );
}
